/**
 * 浦发非标准化接口
 */

import { post } from '@/request/http';
import QS from 'qs';
import JSEncrypt from '../../jsencrypt';

const OtherPage = {

  // 生成借款合同信息
  contDrawGenerateSpdb(params) {
    return post(
      '/backloansuper/loan/supermarket/contDrawGenerateSpdb/v1.0',
      params,
    );
  },
  // 签署借款合同信息
  signDrawGenerateSpdb(params) {
    return post(
      // `https://www.fastmock.site/mock/1e4ab37bd4f2009a9c6b831849505a66/backloansuper/backloansuper/loan/supermarket/signDrawGenerateSpdb/v1.0`,
      '/backloansuper/loan/supermarket/signDrawGenerateSpdb/v1.0',
      params,
    );
  },
  // 授信合同初始化
  contCreditGenerateSpdb(params) {
    return post(
      '/backloansuper/loan/supermarket/contCreditGenerateSpdb/v1.0',
      params,
    );
  },
  // 签署授信合同
  signCreditGenerateSpdb(params) {
    return post(
      '/backloansuper/loan/supermarket/signCreditGenerateSpdb/v1.0',
      params,
    );
  },
  // 签署征信协议
  grantBookCont(params) {
    return post(
      '/backloansuper/loan/supermarket/grantBookCont/v1.0',
      params,
    );
  },
  // 添加银行卡
  addFillCardNumber(params) {
    const obj = JSON.parse(JSON.stringify(params));
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(
      'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
    );
    obj.bankCard = encrypt.encrypt(`${obj.bankCard}`);
    return post('/backloansuper/loan/supermarket/saveSpdbBankCard/v1.0', obj);
  },
  // 提款成功
  getBorrowerinfo(params) {
    return post(
      '????',
      params,
    );
  },
  // // 还款成功
  // getSuccessfulInfo (params) {
  //   return post(
  //     `????`,
  //     params
  //   )
  // },
  // 还款失算
  addOkCalculation(params) {
    return post(
      '/backloansuper/loan/supermarket/repayTrial/v1.0',
      params,
    );
  },
  prepayment(params) {
    return post(
      '/backloansuper/loan/supermarket/repay/v1.0',
      params,
    );
  },
  // 提前还款
  getRestAmt(params) {
    return post(
      '/backloansuper/loan/supermarket/repayPlan/v1.0',
      params,
    );
  },
  // 获取银行卡开卡状态
  getProgressAccount(params) {
    return post(
      '/backloansuper/loan/supermarket/progressAccount/v1.0',
      params,
    );
  },
  // 获取账户信息
  getAccountInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/getAccountInfo/v1.0',
      params,
    );
  },
  // 获取选择支付方式信息回显
  getPayment(params) {
    return post(
      '/backloansuper/loan/supermarket/payment/v1.0',
      params,
    );
  },
  // 亿联获取受托支付
  getYiLianPayment(params) {
    return post(
      '/backloansuper/loan/supermarket/yiLianPayment/v1.0',
      params,
    );
  },
  // 根据卡号反显银行名称
  yilianQueryBankInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/yilian/queryBankInfo/v1.0',
      params,
    );
  },
  // 浦发优企贷-获取选择支付方式信息回显
  getSpdbYQDPayment(params) {
    return post(
      '/backloansuper/loan/supermarket/spdbYQDPayment/v1.0',
      params,
    );
  },
  // 8.13、查询开户信息
  getBankInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/getBankInfo/v1.0',
      params,
    );
  },

  // 标准化-签署合同、提款申请等页面反显信息，根据订单号状态反显不同页面数据
  queryEchoInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/queryEchoInfo/v1.0',
      params,
    );
  },

  // 标准化-提交接口
  commitApply(params) {
    return post(
      '/backloansuper/loan/supermarket/commitApply/v1.0',
      params,
    );
  },
};
export default OtherPage;
